package com.essntl.features.invoice.ui.addeditinvoice.components.content.day

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import com.essntl.uikit.theme.esColorScheme

data class InvoicingDayUiState(
    val index: Int,
    val serviceList: List<ServiceUiState>,
) {
    data class ServiceUiState(
        val id: String,
        val isChecked: Boolean,
        val name: String,
        val price: Int,
        val iconUrl: String?,
        val status: ServiceInvoiceStatus = ServiceInvoiceStatus.ADDING,
    )
}

enum class ServiceInvoiceStatus {
    PAID,
    INVOICED,
    REMOVING,
    NOT_INVOICED,
    ADDING;

    @Composable
    fun color(): Color =
        when (this) {
            PAID -> MaterialTheme.esColorScheme.textTertiary
            INVOICED -> MaterialTheme.esColorScheme.primary
            NOT_INVOICED -> MaterialTheme.esColorScheme.primary
            REMOVING -> MaterialTheme.esColorScheme.textTertiary
            ADDING -> MaterialTheme.esColorScheme.textPrimary
        }
}